import React, { useEffect } from 'react';
import { PartyPopper, ShieldCheck, Video, ArrowRight } from 'lucide-react';
import useDragToScroll from '../../hooks/useDragToScroll';
import sfx from '../../utils/soundEffects';

const FirstSuccessPopup = ({
  isOpen,
  onClose,
}) => {
  const containerRef = useDragToScroll({ direction: 'vertical', speed: 1.3 });
  const cardRef = useDragToScroll({ direction: 'vertical', speed: 1.3 });

  useEffect(() => {
    if (isOpen) {
      sfx.playSuccess();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleContinue = () => {
    sfx.playClick();
    if (onClose) onClose();
  };

  return (
    <div
      ref={containerRef}
      className="first-success-modal-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(3, 7, 18, 0.9)',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1118,
        borderRadius: '16px',
        padding: '10px',
        overflow: 'hidden',
        boxSizing: 'border-box',
        animation: 'fadeIn 0.25s ease',
      }}
    >
      <style>{`
        @keyframes firstSuccessGlow {
          0% { box-shadow: 0 0 15px rgba(242, 184, 7, 0.4); }
          50% { box-shadow: 0 0 35px rgba(242, 184, 7, 0.8); }
          100% { box-shadow: 0 0 15px rgba(242, 184, 7, 0.4); }
        }
      `}</style>

      <div
        ref={cardRef}
        style={{
          background: 'linear-gradient(165deg, rgba(30, 24, 6, 0.98) 0%, rgba(6, 13, 24, 0.99) 100%)',
          border: '2px solid var(--mga-gold)',
          borderRadius: '16px',
          maxWidth: '560px',
          width: '100%',
          maxHeight: '100%',
          overflowY: 'auto',
          boxSizing: 'border-box',
          padding: '22px 26px',
          boxShadow: '0 25px 70px rgba(0, 0, 0, 0.95), 0 0 30px rgba(242, 184, 7, 0.3)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: '14px',
          animation: 'slideUpDuel 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards, firstSuccessGlow 2s ease-in-out infinite',
        }}
      >
        <div style={{
          width: '58px',
          height: '58px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(242, 184, 7, 0.3) 0%, rgba(217, 119, 6, 0.45) 100%)',
          border: '1.5px solid var(--mga-gold)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 15px rgba(242, 184, 7, 0.4)',
        }}>
          <PartyPopper size={28} color="#ffd873" />
        </div>

        <h2 style={{ margin: 0, fontSize: '1.15rem', color: '#ffffff', fontWeight: 900, letterSpacing: '0.3px' }}>
          🎉 Première réussite complète !
        </h2>

        <p style={{ margin: 0, fontSize: '0.85rem', color: '#e2e8f0', lineHeight: 1.5 }}>
          Pour la <strong style={{ color: 'var(--mga-gold)' }}>première fois</strong>, vous avez réussi à faire fuir l'agresseur <strong>avant la fin de son agression</strong>, tout en parvenant à <strong style={{ color: '#4ade80' }}>l'identifier formellement</strong> !
        </p>

        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <div style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            background: 'rgba(16, 185, 129, 0.15)', border: '1px solid rgba(16, 185, 129, 0.4)',
            borderRadius: '10px', padding: '6px 12px', fontSize: '0.74rem', color: '#86efac', fontWeight: 700,
          }}>
            <ShieldCheck size={14} /> Agression interrompue
          </div>
          <div style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            background: 'rgba(56, 189, 248, 0.15)', border: '1px solid rgba(56, 189, 248, 0.4)',
            borderRadius: '10px', padding: '6px 12px', fontSize: '0.74rem', color: '#7dd3fc', fontWeight: 700,
          }}>
            <Video size={14} /> Suspect identifié
          </div>
        </div>

        <button
          type="button"
          onClick={handleContinue}
          style={{
            marginTop: '4px',
            background: 'linear-gradient(135deg, #f2b807 0%, #d97706 100%)',
            color: '#000000',
            border: 'none',
            padding: '11px 22px',
            borderRadius: '12px',
            fontWeight: 900,
            fontSize: '0.88rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 20px rgba(242, 184, 7, 0.45)',
          }}
        >
          <span>Voir le rapport d'enquête</span>
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default FirstSuccessPopup;
